<script>
import commonFunctions from '../../mixins/commonFunctions'
export default {
  mixins: [commonFunctions],
  props: {
    primarySample: {
      type: Object,
      default: null
    },
    secondarySample: {
      type: Object,
      default: null
    },
    isShoppingList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // when only 1 exclude or food selected, it will be string
      // which cause an error when used with join so convert to array first
      selectedItems:
        typeof this.$route?.query?.food === 'string'
          ? [this.$route?.query?.food]
          : this.$route?.query?.food || [],
      selectedExclusions:
        typeof this.$route?.query?.exclude === 'string'
          ? [this.$route?.query?.exclude]
          : this.$route?.query?.exclude || []
    }
  },
  computed: {
    imageUrl () {
      const storagePath = localStorage.getItem('public_storage')
      const distributor = this.primarySample.distributorSlug
      return `${storagePath}report/distributors/${distributor}/images/`
    },
    allFoods () {
      const simplifiedFoods = []
      const glossaryData =
        this.primarySample.glossaryData &&
        this.primarySample.glossaryData.dietarySuggestions &&
        this.primarySample.glossaryData.dietarySuggestions.foods
          ? this.primarySample.glossaryData.dietarySuggestions.foods
          : []
      for (const foodGroupKey in glossaryData) {
        const firstFoodItem = glossaryData[foodGroupKey][0] || null
        const foodGroupObject = {
          displayName: firstFoodItem.group || foodGroupKey,
          key: foodGroupKey,
          foodItems: glossaryData[foodGroupKey]
        }
        simplifiedFoods.push(foodGroupObject)
      }
      return simplifiedFoods
    }
  },
  methods: {
    partitionedAnwsers (arrData) {
      const items = arrData
      const chunkSize = Math.ceil(items.length / 2)
      const groups = []
      for (let i = 0; i < items.length; i += chunkSize) {
        groups.push(items.slice(i, i + chunkSize))
      }
      return groups
    },
    filteredFoods (food) {
      const foods = []
      food.forEach((foodItem) => {
        const matchedItemsInSelectedExcludedFoodTypes = this.intersect(
          foodItem.exclusions,
          this.selectedExclusions
        )
        const matchedItemInSelectedFoodList = this.selectedItems.length
          ? this.intersect([foodItem.key], this.selectedItems)
          : []

        if (
          !this.isShoppingList &&
          !matchedItemsInSelectedExcludedFoodTypes.length
        ) {
          foods.push(foodItem)
        } else if (
          matchedItemInSelectedFoodList.length > 0 &&
          !matchedItemsInSelectedExcludedFoodTypes.length
        ) {
          foods.push(foodItem)
        } else if (
          !matchedItemsInSelectedExcludedFoodTypes.length &&
          !this.selectedItems.length
        ) {
          foods.push(foodItem)
        }
      })
      return !this.isShoppingList ? (foods.length ? foods : food) : foods
    },
    intersect (foodExclusionList, excludedFoodTypes) {
      return foodExclusionList.filter((excludedFood) =>
        excludedFoodTypes.includes(excludedFood)
      )
    }
  }
}
</script>

<style lang="scss">
  .dietry-suggestions-widget {
    font-size: 20px;
    .btn {
      border-radius: 99em;
    }
    .btn-primary,
    .btn-outline-primary,
    .btn-light,
    .btn-outline-light,
    .btn-info,
    .btn-outline-info {
      padding: 0.625rem 1.5rem;
      border-radius: 99em;
    }
    .btn-primary {
      background-color: #ff8708;
      border-color: #ff8708;
      &:hover {
        color: #fff !important;
        background: #ff9c08;
        border-color: #ff9c08;
      }
    }
    .btn-outline-primary {
      color: #ff8708;
      border-color: #ff8708;
      &:hover {
        color: #fff !important;
        background: #ff9c08;
        border-color: #ff9c08;
      }
    }
    h3 {
      font-family: 'athelas', serif !important;
      font-size: 30px !important;
      font-weight: 500 !important;
      color: #0d203d !important;
      margin-bottom: 15px !important;
    }

    p {
      font-size: 20px;
    }

    .list-group {
      padding: 0;
      margin: 0 -5px 0 -10px;
      .shopping-item {
        margin-top: -1px;
        padding: 0;
        padding-inline-end: 10px;
        list-style-type: none;
      }
      .shopping-item-content {
        height: 100%;
        width: 100%;
        margin: 0;
        margin-inline-start: 10px;
        padding: 0.75rem 1.25rem;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.125);
      }
    }

    .form-checkbox,
    .form-radio {
      position: relative;
      max-width: 100%;
      font-size: 18px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;

      label {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        cursor: pointer;
        font-size: 18px;
        font-weight: 300;
        color: #778598;
        padding-inline-start: 30px;
        margin-bottom: 1rem;

        &:before,
        &:after {
          content: '';
          position: absolute;
          width: 20px;
          height: 20px;
          left: 0px;
          top: 1px;
          background-color: transparent;
          transition: all 0.2s ease;
        }

        &:before {
          border: 2px solid #ced4da;
          border-radius: 2px;
        }

        &:after {
          content: '\2713';
          font-family: 'Icons';
          font-style: normal;
          font-weight: normal;
          font-size: 0.8rem;
          line-height: 1;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          color: #ff8708;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
        }

        &:hover,
        &:focus {
          &:before {
            border-color: #ff8708;
          }
          &:before,
          &:after {
            transform: scale(0.85);
          }
        }

        &.small-label {
          font-size: 18px;

          &:before,
          &:after {
            top: 0px;
          }
        }
      }

      input {
        display: none;
        &:checked + label {
          &:before {
            border-color: #ff8708;
          }
          &:after {
            opacity: 1;
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .serif-font {
    font-family: Athelas;
  }

  a {
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .header-img {
    background-size: cover;
    strong {
      color: #fff;
      font-size: 28px;
    }
  }

  .headings {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 15px;
    color: #7a8495;
  }

  .chart-element {
    padding: 15px 0 15px 15px;
    margin: 10px 0;
    background: #fbfbfb;
    border-radius: 10px;
  }

  .humanBlock {
    height: 120px;
  }

  p {
    font-weight: 300;

    & .reduced-margin-bottom {
      margin-bottom: 5px;
    }

    & .smaller-text {
    }
  }

  .btn-curved {
    border-radius: 50px !important;
  }

  .btn-outline {
    padding: 15px 30px !important;
    border: 1px solid #7a8495 !important;
    color: #7a8495 !important;

    & :hover,
    & .active {
      border: 1px solid #584263 !important;
      background: #584263 !important;
      color: #fff !important;
    }
  }

  .btn-small-text {
    font-size: 80% !important;
  }

  .btn-smaller-text {
    font-size: 70% !important;
  }

  .page {
    /*text-align: center;*/
  }

  text.title {
    fill: rgb(44, 62, 80);
    font-size: 10px;
    font-weight: 400;
  }

  .component {
    position: relative;
    background-color: #fff !important;
    border-radius: 5px;
    margin-bottom: 30px;
    /**/
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
  }

  .text-container {
    padding: 30px 30px !important;
    border-right: 1px solid lightgray !important;
    color: #7a8495;
  }

  .component-move {
    position: absolute;
    top: -50px;
    right: 0;

    a {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      width: 50px !important;
      height: 50px !important;
      margin-bottom: 0px;
      text-align: center;
      border-radius: 10px 10px 0 0;
      background: #fff;
      margin-left: 5px;
      color: #000;

      & :first-of-type {
        margin-left: 0;

        & :before {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          height: 75%;
          width: 100%;
          background: #fff;
          z-index: 0;
        }
      }
      i {
        align-self: flex-end;
        display: block;
        position: relative;
        color: #699fca;
        z-index: 100;
        padding: 10px 7px;
        border-radius: 5px;
      }

      & :hover {
        text-decoration: none;

        i {
          background: #f4f4f4;
        }
      }
    }
  }

  .inner-button-group {
    margin-top: 30px;

    button {
      font-size: 14px;
      margin-left: 0 !important;
      border-left: 0;
      border-right: 1px solid #7a8495;
      background: #f4f4f4;

      & :last-of-type {
        border-right: 0;
      }

      & :hover,
      & .active {
        color: #fff !important;
        background: #7a8495 !important;
      }
    }
  }

  .foodWhy {
    font-size: 14px;
    color: #168ccc;
  }

  .shoppingTitle {
    background: #0b1a38;
    height: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding-top: 25px;
    padding-left: 40px;
    padding-right: 40px;
    text-align: start;
  }

  .shoppingTitle .title {
    font-family: 'athelas', serif;
    color: #fff;
    font-size: 30px;
  }

  @media (min-width: 600px) {
    .shoppingSection {
      background: #eeeff0;
      padding: 50px;
      text-align: start;
    }
  }
  @media (max-width: 1200px) {
    .shoppingSection {
      background: #fff;
      padding: 15px;
      text-align: start;
      background: #eeeff0;
    }
    .shoppingSection .list-group-item a {
      margin-left: 30px;
    }
  }
  @media (max-width: 600px) {
    .shoppingSection {
      background: #fff;
      padding: 0px;
      text-align: start;
    }
    .shoppingSection .list-group-item a {
      margin-left: 30px;
    }
    .foodCheckbox {
      display: block !important;
      margin-bottom: 20px;
    }
    label {
      font-size: 20px !important;
    }
  }

  @media (max-width: 800px) {
    .hideSm {
      display: none;
    }
  }

  @media (max-width: 600px) {
    margin-bottom: 15px;
  }

  @media (max-width: 341px) {
    .shoppingTitle {
      height: 140px;
    }
  }

  .foodCheckbox {
    display: inline-block;
    margin-inline-end: 20px;
    font-size: 20px;
  }

  .download-btns {
    text-align: start;
    .btn {
      margin-inline-end: 0.5rem;
    }
  }
  .select-btns {
    text-align: end;
  }
  .rtl {
    .form-checkbox,
    .form-radio {
      label {
        &:before,
        &:after {
          left: initial;
          right: 0;
        }
      }
    }
    .list-group {
      margin: 0 -15px 0 0;
      .text-left {
        text-align: start!important;
      }
      .text-lg-right {
        text-align: end!important;
      }
    }
    .header-img {
      transform: scaleX(-1);
      text-align: end;
      strong {
        display: inline-block;
        transform: scaleX(-1);
      }
    }
  }
</style>
